export default "__VITE_ASSET__CTZxdjGv__"